import { reversalRows } from "@/mocks/homeData";
import { SectionHead, Shell } from "./ui";

export default function ReversalSection() {
  return (
    <section className="bg-background-100/60">
      <Shell>
        <div className="py-10 md:py-14">
          <SectionHead
            id="reverse"
            kicker="Reversal · 事件反转复盘"
            title="反转大事件复盘"
            subtitle="一桩争议如何从否认、晒证一路走向改口与打脸？按轮次逐条还原每个关键反转节点。"
            linkText="反转到此追踪"
          />

          <div className="flex flex-col gap-5">
            {reversalRows.map((row) => (
              <article
                key={row.index}
                className="grid grid-cols-1 gap-0 overflow-hidden rounded-2xl border border-background-200 bg-background-50 md:grid-cols-[auto_1fr]"
              >
                {/* 封面区 */}
                <a href="#top" className="relative block h-52 w-full overflow-hidden md:h-auto md:w-[300px] lg:w-[340px]">
                  <img src={row.src} alt={row.title} className="h-full w-full object-cover transition duration-500 hover:scale-105" />
                  <span className="absolute left-3 top-3 grid h-12 w-12 place-items-center rounded-lg bg-primary-500 font-heading text-xl font-black text-background-50">
                    {row.index}
                  </span>
                </a>
                {/* 内容区 */}
                <div className="flex flex-col gap-4 p-5 md:p-6">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="rounded bg-primary-100 px-2 py-0.5 text-xs font-semibold text-primary-800">{row.round}</span>
                    <span className="text-xs font-medium text-foreground-500">{row.subject}</span>
                    <span className="ml-auto inline-flex items-center gap-1 text-xs font-semibold text-accent-700"><i className="ri-fire-line" />{row.heat}</span>
                  </div>
                  <h3 className="font-heading text-lg font-extrabold leading-snug text-foreground-950 md:text-xl">
                    <a href="#top">{row.title}</a>
                  </h3>

                  <div className="grid grid-cols-1 gap-3 sm:grid-cols-[1fr_auto_1fr] sm:items-stretch">
                    <div className="rounded-xl border-l-4 border-background-300 bg-background-100/60 p-3.5">
                      <div className="mb-1 flex items-center gap-1.5 text-xs font-semibold text-foreground-600">
                        <i className="ri-arrow-up-line text-background-500" />此前的说法
                      </div>
                      <p className="text-sm leading-relaxed text-foreground-800">{row.before}</p>
                    </div>
                    <div className="hidden items-center justify-center sm:flex">
                      <span className="grid h-8 w-8 place-items-center rounded-full bg-foreground-950 text-background-50"><i className="ri-arrow-right-line" /></span>
                    </div>
                    <div className="rounded-xl border-l-4 border-primary-500 bg-primary-50/70 p-3.5">
                      <div className="mb-1 flex items-center gap-1.5 text-xs font-semibold text-primary-700">
                        <i className="ri-arrow-down-line text-primary-500" />事后的实情
                      </div>
                      <p className="text-sm leading-relaxed text-foreground-800">{row.after}</p>
                    </div>
                  </div>

                  <p className="text-sm leading-relaxed text-foreground-600">
                    <span className="mr-2 inline-flex items-center gap-1 rounded-full bg-secondary-100 px-2 py-0.5 text-xs font-semibold text-secondary-900">
                      <i className="ri-verified-badge-line" />结论
                    </span>
                    {row.verdict}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </Shell>
    </section>
  );
}